import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../shared/shared.module';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {KtCogsFilterService} from '../../service/kt-cogs-filter.service';
import {KtCogsFilterModel} from '../../models/kt-filter.model';

@Component({
  selector: 'app-kt-cogs-filter-modal',
  imports: [
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './kt-cogs-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
  `],
})
export class KtCogsFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<KtCogsFilterModalComponent>);
  private readonly filterService = inject(KtCogsFilterService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;
  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const f = this.filterService.filtersValue();
    this.form.patchValue({
      TripReference: f.TripReference,
      VendorName: f.VendorName,
      ProductTypeName: f.ProductTypeName,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: KtCogsFilterModel = {
      TripReference: raw.TripReference,
      VendorName: raw.VendorName,
      ProductTypeName: raw.ProductTypeName,
      ReloadGrid: true,
    };
    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      TripReference: null,
      VendorName: null,
      ProductTypeName: null,
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
